import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import {
    BusinessServiceFilter,
    NetworkDeviceTypeFilter,
    SiteFilter,
    StatusFilter,
    TimeRangeFilter,
} from '../../filters';
import { DeviceListPanel } from '../../panels';

export const pageId = 'network-devices';

export default function NetworkDevicesPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Network Devices`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <BusinessServiceFilter />
                    <NetworkDeviceTypeFilter />
                    <SiteFilter />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <DeviceListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
